import React from "react";
import {Col, Row} from "antd";

export default props => {

    return (
        <Row style={{marginTop: 16}} onClick={props.onClick}>
            <Col span={24}>
                <div className={"account-card"} style={props.style}>
                    {props.children}
                </div>
            </Col>
        </Row>
    )
}
